import React from "react";
import assetify from "@quintype/framework/assetify";
import { string, number, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import DefaultDesktopLogo from "../icons/default-desktop-logo";
import KiaLogo from "../icons/kia-logo";
import BondhushavaLogo from "../icons/BondhuShavaLogo";
import protichintaIcon from "../../../../assets/images/protichinta-icon.png";
import BigganChintaLogo from "../icons/BigganChintaLogo";
import trustLogo from "../../../../assets/images/trust-logo.png";
import EnglishHeaderLogo from "../icons/EnglishHeaderLogo";
import { headerLevelLogo } from "../../utils/utils";
import NagorikLogo from "../icons/NagorikLogo";

import "./desktopLogo.m.css";

const DesktopLogo = ({ width = 160, height = 80, domainSlug, publisherAttributes, pageType }) => {
  const HeaderTag = `h${headerLevelLogo(pageType)}`;
  const renderLogo = () => {
    switch (domainSlug) {
      case "kishoralo":
        return <KiaLogo width={width} height={height} />;
      case "bondhushava":
        return <BondhushavaLogo width={width} height={height} />;
      case "protichinta":
        return (
          <img
            src={`${assetify(protichintaIcon)}`}
            alt="ad-slot-768-x90"
            styleName="protichinta-logo"
            className="protichinta-desktop-logo"
          />
        );
      case "biggan-chinta":
        return <BigganChintaLogo width={width} height={height} />;
      case "bigganchinta":
        return <BigganChintaLogo width={width} height={height} />;
      case "trust":
        return <img src={`${assetify(trustLogo)}`} alt="trust-logo" className="desktop-trust-logo trust-logo" />;
      case "nagorik-sangbad":
        return <NagorikLogo width="333" height="45" />;
      default:
        return publisherAttributes.lang === "en" ? (
          <EnglishHeaderLogo
            width="230"
            height={pageType === "section-page" || pageType === "home-page" ? "78" : "51.7"}
          />
        ) : (
          <DefaultDesktopLogo width={width} height={height} />
        );
    }
  };

  return <HeaderTag className="desktop-logo">{renderLogo()}</HeaderTag>;
};

const mapStateToProps = state => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  pageType: get(state, ["qt", "pageType"], "")
});

DesktopLogo.propTypes = {
  domainSlug: string,
  width: number,
  height: number,
  publisherAttributes: object,
  pageType: string
};

export default connect(mapStateToProps, null)(DesktopLogo);
